import { ContactsBoxProps } from './contacts.types';

export const ContactsBox: React.FC<ContactsBoxProps> = ({
    ...props
}) => {
    return (
        <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
            <div className="bg-brandPrimary-600 px-4 py-3">
                <span className="text-white text-sm font-semibold uppercase tracking-widest">Rubrica</span>
            </div>

            <div className="p-4 flex flex-col gap-3">
                <div className="flex justify-between gap-4 items-start text-left">
                    <span className="text-sm font-semibold text-brandPrimary-700">Telefono</span>
                    <span className="text-sm font-medium text-neutral-700">{props.contacts?.phone || '-'}</span>
                </div>

                <div className="border-t border-neutral-200" />

                <div className="flex justify-between gap-4 items-start text-left">
                    <span className="text-sm font-semibold text-brandPrimary-700">Telefono ufficio</span>
                    <span className="text-sm font-medium text-neutral-700">{props.contacts?.officePhone || '-'}</span>
                </div>

                <div className="border-t border-neutral-200" />

                <div className="flex justify-between gap-4 items-start text-left">
                    <span className="text-sm font-semibold text-brandPrimary-700">Cellulare</span>
                    <span className="text-sm font-medium text-neutral-700">{props.contacts?.mobilePhone || '-'}</span>
                </div>

                <div className="border-t border-neutral-200" />

                <div className="flex justify-between gap-4 items-start text-left">
                    <span className="text-sm font-semibold text-brandPrimary-700">Email</span>
                    <span className="text-sm font-medium text-neutral-700">{props.contacts?.email || '-'}</span>
                </div>

                <div className="border-t border-neutral-200" />

                <div className="flex justify-between gap-4 items-start text-left">
                    <span className="text-sm font-semibold text-brandPrimary-700">Email personale</span>
                    <span className="text-sm font-medium text-neutral-700">{props.contacts?.personalEmail || '-'}</span>
                </div>

                <div className="border-t border-neutral-200" />

                <div className="flex justify-between gap-4 items-start text-left">
                    <span className="text-sm font-semibold text-brandPrimary-700">PEC</span>
                    <span className="text-sm font-medium text-neutral-700">{props.contacts?.pec || '-'}</span>
                </div>

                <div className="border-t border-neutral-200" />

                <div className="flex justify-between gap-4 items-start text-left">
                    <span className="text-sm font-semibold text-brandPrimary-700">Note</span>
                    <span className="text-sm font-medium text-neutral-700">{props.contacts?.note || '-'}</span>
                </div>
            </div>
        </div>
    );
}
